import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { StyledButton } from '../../components';
import { isOperation, isNumeric, DoTheMath } from './helper';
import { Container, NumPad, CalculatorInput } from './styled';
export const Calculator = () => {
    // TODO: add 1 more string with current math state
    const [currentNumber, setCurrentNumber] = useState('');
    const [memoryNumber, setMemoryNumber] = useState('');
    const [operation, setOperation] = useState(null);
    const [equalCounter, setEqualCounter] = useState(0);
    const checkKeyboardEvent = (event) => {
        const key = event.key;
        if (isNumeric(key)) {
            digitHandler(Number(key));
        }
        else if (isOperation(key)) {
            operationHandler(key);
        }
        else if (key === '=' || key === 'Enter') {
            equalHandler();
        }
        else if (event.key === 'Backspace') {
            functionalHandler('remove');
        }
    };
    useEffect(() => {
        document.addEventListener('keydown', checkKeyboardEvent, false);
        return () => {
            document.removeEventListener('keydown', checkKeyboardEvent, false);
        };
    });
    const digitHandler = (value) => {
        if (equalCounter > 0)
            setEqualCounter(0);
        if (operation && !memoryNumber) {
            setMemoryNumber(currentNumber);
            setCurrentNumber(value.toString());
        }
        else {
            setCurrentNumber(prev => {
                return prev + value;
            });
        }
    };
    const operationHandler = (value) => {
        if (notEmpty()) {
            if (operation)
                setMemoryNumber('');
            setOperation(value);
        }
    };
    const equalHandler = () => {
        if ((memoryNumber || currentNumber) && operation) {
            if (memoryNumber === '') {
                setCurrentNumber(prev => {
                    setMemoryNumber(prev);
                    return DoTheMath(currentNumber, currentNumber, operation).toString();
                });
            }
            else {
                setCurrentNumber(prev => {
                    if (equalCounter > 0) {
                        return DoTheMath(prev, memoryNumber, operation).toString();
                    }
                    else {
                        setMemoryNumber(prev);
                        return DoTheMath(memoryNumber, prev, operation).toString();
                    }
                });
            }
            setEqualCounter(prev => prev + 1);
        }
    };
    const clear = () => {
        setCurrentNumber('');
        setMemoryNumber('');
        setOperation(null);
    };
    const functionalHandler = (key) => {
        switch (key) {
            case 'remove': {
                if (currentNumber === '')
                    clear();
                setCurrentNumber(prev => {
                    if (prev.length)
                        prev = prev.slice(0, -1);
                    return prev;
                });
                break;
            }
            case 'clear': {
                clear();
                break;
            }
            case 'fractional': {
                setCurrentNumber(prev => `${prev}.`);
                break;
            }
            case 'percent': {
                setCurrentNumber(prev => {
                    return ((Number(prev) / 100) * Number(memoryNumber || 1)).toString();
                });
                break;
            }
            case 'reverse': {
                if (currentNumber === '0' || currentNumber === '')
                    return;
                setCurrentNumber(prev => {
                    return Number(prev) > 0 ? `-${prev}` : Math.abs(Number(prev)).toString();
                });
                break;
            }
        }
    };
    const notEmpty = () => {
        return currentNumber !== '' || memoryNumber !== '' || operation;
    };
    return (_jsxs(Container, { children: [_jsx(CalculatorInput, { type: "string", value: Number(currentNumber), onChange: event => event.preventDefault() }), _jsxs(NumPad, { children: [_jsx(StyledButton, { onClick: () => functionalHandler('clear'), children: notEmpty() ? 'C' : 'AC' }), _jsx(StyledButton, { onClick: () => functionalHandler('reverse'), children: "+/-" }), _jsx(StyledButton, { onClick: () => functionalHandler('percent'), children: "%" }), _jsx(StyledButton, { onClick: () => functionalHandler('remove'), children: '<' }), _jsx(StyledButton, { onClick: () => digitHandler(1), children: "1" }), _jsx(StyledButton, { onClick: () => digitHandler(2), children: "2" }), _jsx(StyledButton, { onClick: () => digitHandler(3), children: "3" }), _jsx(StyledButton, { onClick: () => operationHandler('/'), "$active": operation === '/', children: "/" }), _jsx(StyledButton, { onClick: () => digitHandler(4), children: "4" }), _jsx(StyledButton, { onClick: () => digitHandler(5), children: "5" }), _jsx(StyledButton, { onClick: () => digitHandler(6), children: "6" }), _jsx(StyledButton, { onClick: () => operationHandler('*'), "$active": operation === '*', children: "*" }), _jsx(StyledButton, { onClick: () => digitHandler(7), children: "7" }), _jsx(StyledButton, { onClick: () => digitHandler(8), children: "8" }), _jsx(StyledButton, { onClick: () => digitHandler(9), children: "9" }), _jsx(StyledButton, { onClick: () => operationHandler('-'), "$active": operation === '-', children: "-" }), _jsx(StyledButton, { onClick: () => digitHandler(0), children: "0" }), _jsx(StyledButton, { value: "fractional", onClick: () => functionalHandler('fractional'), children: "." }), _jsx(StyledButton, { onClick: () => operationHandler('+'), "$active": operation === '+', children: "+" }), _jsx(StyledButton, { value: "equals", onClick: equalHandler, children: "=" })] })] }));
};
